import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { USER_LOGOUT } from './constants';
import {
  IUserLogoutSuccess,
  IUserLogoutError,
  UserLogoutDataActionTypes,
  IUserLogoutState,
} from './types';

const initialState: IUserLogoutState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: UserLogoutDataActionTypes,
  ): IUserLogoutState => {
    switch (action.type) {
      case USER_LOGOUT + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case USER_LOGOUT + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as IUserLogoutSuccess).payload;
        break;
      }
      case USER_LOGOUT + FAILURE: {
        draft.status = rejected;
        draft.error = (action as IUserLogoutError).error;
        break;
      }
      default:
        return draft;
    }
  },
);
